<!-- 当号码重复的时候产生的弹窗  -->
<template>
  <confirm :title="confirm.title" cancelText="取消" confirmText="确定" v-model="confirmShow" @on-confirm="handleOnConfirm()">
    <p class="confirm-tip">{{confirm.desc}}</p>
  </confirm>
</template>

<script>
import { Confirm } from '@lx-frontend/cvux'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    confirm: {
      type: Object,
      required: true
    }
  },
  components: { Confirm },
  data() {
    return {
      confirmShow: false
    }
  },
  created() {
    this.confirmShow = this.show
  },
  watch: {
    confirmShow(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.confirmShow = val
    }
  },
  methods: {
    async handleOnConfirm() {
      const { fromCustomerId, toCustomerId, type } = this.confirm
      if (type === 'add') {
        this.runNewCustomer(toCustomerId)
        return
      }
      const body = {
        from_customer_id: fromCustomerId,
        to_customer_id: toCustomerId
      }

      this.switchLoading({ status: true, text: '' })
      const res = await this.$rest.carRegister.tansferCar(body)
      this.switchLoading({ status: false })

      if (res.code !== 0) {
        this.$message.fail(res.message)
        return
      }
      this.runNewCustomer(toCustomerId)
    },
    runNewCustomer(id) {
      this.$router.push({
        path: '/carregister/record',
        query: { customerId: id }
      })
    }
  }
}
</script>
<style lang='less' scoped>
.confirm-tip {
  text-align: center;
}
</style>
